import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../INVENTORY/Assets/styles/addmenu.css';
import '../INVENTORY/Assets/styles/style.css';
import '../SalesTrading/Assets/Style/style.css';
import { getRole } from '../Redux/selecters/index';
import PlainLayout from '../POS/component/pages/SideBar/plainLayout';
import Signup from '../POS/component/pages/user/signup';
import { CurrencyProvider } from '../INVENTORY/Layouts/currencyContext';
import InventoryLogin from '../INVENTORY/Components/login/login';
import MainPMLayout from '../PropertyManagement/Layouts/mainLayout';
import PropertyDashBoard from '../PropertyManagement/Pages/dashboard/dashBoard';
import LeaseListing from '../PropertyManagement/Pages/leaseAgreement/leaseListing';
import AddLeaseAgrement from '../PropertyManagement/Pages/leaseAgreement/addLease';
import LeaseApproval from '../PropertyManagement/Pages/Approval/approval';
import SingleInvoice from '../PropertyManagement/Pages/invoice/singleInvoice';
import InstallmentInvoice from '../PropertyManagement/Pages/invoice/installmentInvoice';
import LeaseTermination from '../PropertyManagement/Pages/leaseTermination/leaseTermination';
import BulkReceipt from '../PropertyManagement/Pages/bulkReceipt/bulkReceipt';
import LeaseBulkList from '../PropertyManagement/Pages/bulkReceipt/bulkReceiptListing';
import OneReceipt from '../PropertyManagement/Pages/OneReceipt/leaseOneReceipt';
import OneReceiptList from '../PropertyManagement/Pages/OneReceipt/listing';
import AddLeaseAgrementView from '../PropertyManagement/Pages/leaseAgreement/leaseAggrementView';
import EditLeaseAgrement from '../PropertyManagement/Pages/leaseAgreement/editLease/editLease';
import LeaseAgreementRenew from '../PropertyManagement/Pages/leaseAgreement/leaseRenew/leaseRenew';
import LeaseGeneralInvoice from '../PropertyManagement/Pages/leaseGeneralInvoice/leaseGeneralInvoice';
import LeaseRevenue from '../PropertyManagement/Pages/posting/leaseRevenue';
import DashLeaseAgrement from '../PropertyManagement/Pages/leaseAgreement/editLease/leaseAgreementDash';
import LeaseReceipt from '../PropertyManagement/Pages/leaseReceipt/leaseReceipt';
import LeaseReceiptDash from '../PropertyManagement/Pages/leaseReceipt/leaseReceiptDashboard';
import LeaseReceiptListing from '../PropertyManagement/Pages/leaseReceipt/receiptListing';
import SingleInvoiceListing from '../PropertyManagement/Pages/invoice/singleInvoiceListing';
import InstallmentInvoiceListing from '../PropertyManagement/Pages/invoice/instalmentInvoiceListing';
import TerminationListing from '../PropertyManagement/Pages/leaseTermination/listing';
import PaymentManagement from '../PropertyManagement/Pages/managepayment/managePayment';
import ReverseReceipt from '../PropertyManagement/Pages/reverseReceipt/reverseReceipt';
import ListingDashBoard from '../PropertyManagement/Pages/dashboard/listingDashboard';
import CreateLeaseReservation from '../PropertyManagement/Pages/leaseReservation/leaseReservation';
import ReservationListing from '../PropertyManagement/Pages/leaseReservation/reservationListing';
import LeaseRevenueList from '../PropertyManagement/Pages/leaseRevenue/leaseRevenue';

const AppRoutes = () => {
  const role = useSelector(getRole);
  const [userRole, setUserRole] = useState(role);

  return (
    <CurrencyProvider>
      <Routes>
        {!userRole && (
          <>
            <Route path="/login" element={<PlainLayout> <InventoryLogin /> </PlainLayout>} />
            <Route path="/signup" element={<PlainLayout> <Signup /></PlainLayout>} />
          </>
        )}
        <>
          {/* Property Management */}
          <Route path="/" element={<MainPMLayout><PropertyDashBoard /></MainPMLayout>} />
          <Route path="/listing" element={<MainPMLayout><ListingDashBoard /></MainPMLayout>} />
          <Route path="/Property/Management/LeaseAgreement" element={<MainPMLayout><LeaseListing /></MainPMLayout>} />
          <Route path="/Property/Management/LeaseAgreement/:id" element={<MainPMLayout><AddLeaseAgrementView /></MainPMLayout>} />
          <Route path="/Property/Management/LeaseAgreement/Create" element={<MainPMLayout><AddLeaseAgrement /></MainPMLayout>} />
          <Route path="/Property/Management/LeaseAgreement/edit/:id" element={<MainPMLayout><EditLeaseAgrement /></MainPMLayout>} />
          <Route path="/Property/Management/LeaseAgreement/renew/:id" element={<MainPMLayout><LeaseAgreementRenew /></MainPMLayout>} />
          <Route path="/Property/Management/LeaseAgreement/Create/:id" element={<MainPMLayout><DashLeaseAgrement /></MainPMLayout>} />
          <Route path="/Property/Management/Approval" element={<MainPMLayout><LeaseApproval /></MainPMLayout>} />
          <Route path="/Property/Management/Single/Invoice" element={<MainPMLayout><SingleInvoice /></MainPMLayout>} />
          <Route path="/Property/Management/Single/Invoice/Listing" element={<MainPMLayout><SingleInvoiceListing /></MainPMLayout>} />
          <Route path="/Property/Management/Installment/Invoice" element={<MainPMLayout><InstallmentInvoice /></MainPMLayout>} />
          <Route path="/Property/Management/Installment/Invoice/Listing" element={<MainPMLayout><InstallmentInvoiceListing /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/Termination" element={<MainPMLayout><LeaseTermination /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/Termination/Listing" element={<MainPMLayout><TerminationListing /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/GeneralInvoice" element={<MainPMLayout><LeaseGeneralInvoice /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/RevenuePosting" element={<MainPMLayout><LeaseRevenueList /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/Bulk/Receipt" element={<MainPMLayout><BulkReceipt /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/Bulk/Receipt/Listing" element={<MainPMLayout><LeaseBulkList /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/One/Receipt" element={<MainPMLayout><OneReceipt /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/One/Receipt/Listing" element={<MainPMLayout><OneReceiptList /></MainPMLayout>} />
          <Route path="/Lease/Management/Lease/Receipt/create" element={<MainPMLayout><LeaseReceipt /></MainPMLayout>} />
          <Route path="/Lease/Management/Lease/Receipt/:id" element={<MainPMLayout><LeaseReceiptDash /></MainPMLayout>} />
          <Route path="/Lease/Management/Lease/Receipt/Listing" element={<MainPMLayout><LeaseReceiptListing /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/Payment/Management" element={<MainPMLayout><PaymentManagement /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/Reverse/Receipt" element={<MainPMLayout><ReverseReceipt /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/Reservation/Listing" element={<MainPMLayout><ReservationListing /></MainPMLayout>} />
          <Route path="/Property/Management/Lease/Reservation/Create" element={<MainPMLayout><CreateLeaseReservation /></MainPMLayout>} />
          {/* <Route path="/Property/Management/Lease/Revenue" element={<MainPMLayout><LeaseRevenueList /></MainPMLayout>} /> */}
        </>
      </Routes>
    </CurrencyProvider>
  );
};

export default AppRoutes;
